module.exports = __webpack_public_path__ + "img/if_7.06383355.png";